import { ClassConstructor, plainToInstance } from 'class-transformer';

import { GenericApiResponseMeta } from '../type';
import { PaginationModel } from './pagination.model';

export class GenericApiResponseModel<T> {
  pagination!: PaginationModel;
  results!: T[];

  constructor(cls: ClassConstructor<T>, plain: { meta: Partial<GenericApiResponseMeta>; items: unknown[] }) {
    this.pagination = PaginationModel.fromJson(plain.meta);
    this.results = plainToInstance(cls, plain.items);
  }
}
